export const guestAlreadyRegistered = (guest) => Boolean(guest?.id);

export const shouldLockGuestIdentity = (guest, { forceEditable } = {}) => {
  if (forceEditable) return false;
  return guestAlreadyRegistered(guest);
};

export const GUEST_MISSING_DATA_BUTTON = 'Modificar datos';

export const lockedGuestMissingDataMessage = `Por favor haz clic en "${GUEST_MISSING_DATA_BUTTON}" para completar tu información.`;

export const GUEST_IDENTITY_FIELDS = [
  'name',
  'lastName',
  'identification',
  'phone',
  'email',
  'gender',
  'civil',
  'birthdate',
  'photo',
];

export const clearGuestFieldErrors = (prevErrors = {}, guest = {}) => {
  const next = { ...prevErrors };
  GUEST_IDENTITY_FIELDS.forEach((field) => {
    if (guest[field]) next[field] = false;
  });
  return next;
};

export const guestProfileEditPath = (guest = {}) => {
  const params = new URLSearchParams();
  if (guest.identification != null && String(guest.identification).trim() !== '') {
    params.set('identification', String(guest.identification).trim());
  }
  if (guest.phone != null && String(guest.phone).trim() !== '') {
    params.set('phone', String(guest.phone).trim());
  }
  params.set('edit', '1');
  return `/perfil/info?${params.toString()}`;
};
